<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="screen-item" :class="isLeft ? 'screen-item-left': 'screen-item-top'" :style="{ '--theme-color': themeColor, '--opacity-theme': colorRgb(themeColor, 0.4) }">
    <template v-if="isDefault">
      <div v-if="isMultiple" class="screen-item-multiple">
        <template v-if="info.showType === 'tranL'">
          <div class="single-tree-head" v-if="info.isSearch">
            <el-input placeholder="输入关键字进行过滤" size="small" v-model="optSearch" />
            <el-icon size="24" color="#4e86ff" style="margin-left: 8px" @click="init">
              <RefreshRight />
            </el-icon>
          </div>
          <el-checkbox style="height: 40px;line-height: 40px;" v-if="info.isAppenAll !== false" v-model="info.checkAll" @change="checkChange"><span :style="getFontStyle" >全部</span></el-checkbox>
          <el-checkbox-group v-model="value" @change="checkChange" style="display: flex; flex-direction: column;">
            <template v-if="isObject(optSearchList[0])">
              <el-checkbox class="h-fit" v-for="(Sel, j) in optSearchList" :label="Sel" :key="j">
                <optionItem @todo-inside="$emit('todo-inside', $event)" @openAppInitiate="$emit('openAppInitiate', $event)" @open-dictionary="$emit('open-dictionary',$event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" :styleInfo="getFontStyle" />
              </el-checkbox>
            </template>
            <template v-else>
              <el-checkbox class="h-fit" v-for="(Sel, j) in optSearchList" :label="Sel" :key="j">
                <optionItem @todo-inside="$emit('todo-inside', $event)" @openAppInitiate="$emit('openAppInitiate', $event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" :styleInfo="getFontStyle" />
              </el-checkbox>
            </template>
          </el-checkbox-group>
        </template>
        <template v-else-if="info.showType === 'putItAway'">
          <el-popover v-model="isAppenPop">
            <template #reference>
              <div class="detail-screen-default-orgselect" ref="orgSelectRef">
                <el-select @click.stop="showOrgAndRoleList" class="detail-screen-default-orgselect-pop" :placeholder="info.placeholder || '请选择'" multiple @remove-tag="removeTag" collapse-tags :value="orgAndRoleAppenText" :readonly="true" style="overflow: hidden;" :popper-append-to-body="false" />
              </div>
            </template>
            <div>
              <el-input v-model="optSearch" placeholder="请搜索">
                <template #prefix>
                  <el-icon><Search /></el-icon>
                </template>
              </el-input>
              <el-checkbox v-model="checkAll" @change="checkChange" style="margin: 10px 0;" v-if="info.isAppenAll !== false">全部</el-checkbox>
              <el-checkbox-group v-model="value" @change="checkChange" style="display: flex; flex-direction: column;">
                <template v-if="isObject(optSearchList[0])">
                  <el-checkbox v-for="(Sel, j) in optSearchList" :label="Sel" :key="j">
                    <optionItem @todo-inside="$emit('todo-inside', $event)" @open-dictionary="$emit('open-dictionary',$event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)"  :selInfo="Sel" />
                  </el-checkbox>
                </template>
                <template v-else>
                  <el-checkbox v-for="(Sel, j) in optSearchList" :label="Sel" :key="j">
                    <optionItem @todo-inside="$emit('todo-inside', $event)" @open-dictionary="$emit('open-dictionary',$event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" />
                  </el-checkbox>
                </template>
              </el-checkbox-group>
            </div>
          </el-popover>
        </template>
      </div>
      <template v-else>
        <template v-if="isLeft">
          <template v-if="info.showType === 'tranL'">
            <template v-if="isObject(optSearchList[0])">
              <div class="single-tree-head" v-if="info.isSearch">
                <el-input placeholder="输入关键字进行过滤" size="small" v-model="optSearch" />
                <el-icon size="24" color="#4e86ff" style="margin-left: 8px" @click="init">
                  <RefreshRight />
                </el-icon>
              </div>
              <div class="single-item" v-if="info.isAppenAll !== false" :style="[{background: value[0] === '全部' ? colorRgb(themeColor, 0.1) : '' }, getFontStyle]" @click="checkSingle('全部')" :class="value[0] === '全部' ? 'single-item-active' : ''">
                <optionItem @todo-inside="$emit('todo-inside', $event)" @openAppInitiate="$emit('openAppInitiate', $event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" selInfo="全部" v-bind="btnProps" :styleInfo="getFontStyle" />
              </div>
              <div @click="checkSingle(sel)" :style="[{ background: inputAppenText[0] === sel.value ? colorRgb(themeColor, 0.1) : '' }, getFontStyle]" class="single-item" :class="inputAppenText[0] === sel.value ? 'single-item-active' : ''" v-for="(sel, idx) in optSearchList" :key="idx">
                <optionItem @todo-inside="$emit('todo-inside', $event)" @openAppInitiate="$emit('openAppInitiate', $event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" :selInfo="sel" v-bind="btnProps" :styleInfo="getFontStyle" />
              </div>
            </template>
            <template v-else>
              <div class="single-tree-head" v-if="info.isSearch">
                <el-input placeholder="输入关键字进行过滤" size="small" v-model="optSearch" />
                <el-icon size="24" color="#4e86ff" style="margin-left: 8px" @click="init">
                  <RefreshRight />
                </el-icon>
              </div>
              <div class="single-item" v-if="info.isAppenAll !== false" :style="[{background: value[0] === '全部' ? colorRgb(themeColor, 0.1) : '' }, getFontStyle]" @click="checkSingle('全部')" :class="value[0] === '全部' ? 'single-item-active' : ''">
                <optionItem @todo-inside="$emit('todo-inside', $event)" @openAppInitiate="$emit('openAppInitiate', $event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" selInfo="全部" :styleInfo="getFontStyle" />
              </div>
              <div @click="checkSingle(sel)" :style="[{ background: value[0] === sel ? colorRgb(themeColor, 0.1) : '' }, getFontStyle]" class="single-item" :class="value[0] === sel ? 'single-item-active' : ''" v-for="sel in optSearchList" :key="sel">
                <optionItem @todo-inside="$emit('todo-inside', $event)" @openAppInitiate="$emit('openAppInitiate', $event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" :selInfo="sel" :styleInfo="getFontStyle" />
              </div>
            </template>
          </template>
          <template v-else>
            <el-popover v-model="isAppenPop">
              <template #reference>
                <div class="detail-screen-default-orgselect" ref="orgSelectRef">
                  <el-select @click.stop="showOrgAndRoleList" class="detail-screen-default-orgselect-pop" :placeholder="info.placeholder || '请选择'" multiple @remove-tag="removeTag" collapse-tags :value="orgAndRoleAppenText" :readonly="true" style="overflow: hidden;" :popper-append-to-body="false" />
                </div>
              </template>
              <div>
                <el-input v-model="optSearch" placeholder="请搜索">
                  <template #prefix>
                    <el-icon><Search /></el-icon>
                  </template>
                </el-input>
                <el-checkbox v-model="checkAll" @change="checkSingle('全部')" style="margin: 10px 0;" v-if="info.isAppenAll !== false">全部</el-checkbox>
                <el-checkbox-group v-model="value" @change="checkSingle" style="display: flex; flex-direction: column;">
                  <template v-if="isObject(optSearchList[0])">
                    <el-checkbox v-for="(Sel, j) in optSearchList" :label="Sel" :key="j">
                      <optionItem @todo-inside="$emit('todo-inside', $event)" @open-dictionary="$emit('open-dictionary',$event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)"  :selInfo="Sel" />
                    </el-checkbox>
                  </template>
                  <template v-else>
                    <el-checkbox v-for="(Sel, j) in optSearchList" :label="Sel" :key="j">
                      <optionItem @todo-inside="$emit('todo-inside', $event)" @open-dictionary="$emit('open-dictionary',$event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" />
                    </el-checkbox>
                  </template>
                </el-checkbox-group>
              </div>
            </el-popover>
          </template>
        </template>
        <template v-else>
          <div style="height: 100%" class="verticalL">
            <div style="width:calc(100% - 30px);overflow: hidden">
              <div class="verticalL-item" ref="verticalLItem">
                <div class="single-item" :style="getFontStyle" v-if="info.isAppenAll !== false" ref="singleItemAll" @click="checkSingle('全部')" :class="value[0] === '全部' ? 'single-item-active' : ''">全部</div>
                <template v-if="isObject(optSearchList[0])">
                  <div @click="checkSingle(sel)" ref="singleItem" class="single-item" :style="getFontStyle" :class="inputAppenText[0] === sel.value ? 'single-item-active' : ''" v-for="(sel, idx) in optSearchList" :key="idx">
                    <optionItem @todo-inside="$emit('todo-inside', $event)" @openAppInitiate="$emit('openAppInitiate', $event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" :selInfo="sel" v-bind="btnProps" :styleInfo="getFontStyle" />
                  </div>
                </template>
                <template v-else>
                  <div @click="checkSingle(sel)" ref="singleItem" class="single-item" :style="getFontStyle" :class="value[0] === sel ? 'single-item-active' : ''" v-for="sel in optSearchList" :key="sel">
                    <optionItem @todo-inside="$emit('todo-inside', $event)" @openAppInitiate="$emit('openAppInitiate', $event)" @custom-scene="$emit('custom-scene',$event)" @to-nav="$emit('to-nav', $event)" @open-appDialog="$emit('open-appDialog', $event)" :selInfo="sel" v-bind="btnProps" :styleInfo="getFontStyle" />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </template>
    </template>
    <template v-else-if="isNum || isDate">
      <div class="screen-item-condition">
        <el-select v-model="conditionValue" class="detail-screen-default-select">
          <el-option :key="idx" :value="item.val" :label="item.name" v-for="(item,idx) in looperOption" />
        </el-select>
        <el-date-picker
          v-if="isDate"
          v-model="value"
          type="daterange"
          value-format="YYYY-MM-DD"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          @change="dealCondition"
          class="detail-screen-default-date"
        ></el-date-picker>
        <template v-else-if="isNum">
          <template v-if="isBetween">
            <el-input @change="dealCondition" type="number" v-model="value[0]" />
            <div style="display:inline-block;width:7%;color:#666666;text-align:center;">----</div>
            <el-input @change="dealCondition" type="number" v-model="value[1]" />
          </template>
          <template v-else>
            <el-input @change="dealCondition" type="number" v-model="value[0]" />
          </template>
        </template>
      </div>
    </template>
    <div v-else-if="isUser">
      <!-- 联系人控件 -->

    </div>
    <div v-else-if="isRole || isOrganize">
      <!-- 组织控件和角色控件 -->
      <template v-if="info.showType === 'tranL'">
        <template v-if="isMultiple">
          <el-checkbox-group v-model="orgAndRoleListValue">
            <el-checkbox v-for="(item) in optSearchList" :label="item[isOrganize ? 'organizationId' : 'roleId']" :key="item[isOrganize ? 'organizationId' : 'roleId']">{{ showOrgName(item) }}</el-checkbox>
          </el-checkbox-group>
        </template>
        <template v-else>
          <div class="org-and-role-search-single">
            <div v-if="info.isAppenAll" :style="{ backgroundColor: isActiveRoleAndOrg('全部') ? themeColor : '', color: isActiveRoleAndOrg('全部') ? '#fff' : ''  }" class="org-and-role-search-single-item" @click="orgAndRoleSearchClick('全部')">全部</div>
            <div :style="{ backgroundColor: isActiveRoleAndOrg(item) ? themeColor : '', color: isActiveRoleAndOrg(item) ? '#fff' : ''  }" class="org-and-role-search-single-item" v-for="item in optSearchList" :key="isRole ? item.roleId : item.organizationId" @click="orgAndRoleSearchClick(item)">{{ showOrgName(item) }}</div>
          </div>
        </template>
      </template>
      <template v-else>
        <el-popover v-model="isAppenPop" popper-class="screen-popp" :style="isLeft ? 'display: flex;align-items: center; width: 100%;' : 'flex: 1;height: 100%;'" placement="bottom" :width="userPopWidth">
          <template #reference>
            <div class="detail-screen-default-orgselect" ref="orgSelectRef">
              <el-select @click.stop="showOrgAndRoleList" class="detail-screen-default-orgselect-pop" :placeholder="info.placeholder || '请选择'" multiple @remove-tag="removeTag" collapse-tags :value="orgAndRoleAppenText" :readonly="true" style="overflow: hidden;" :popper-append-to-body="false" />
            </div>
          </template>
          <div style="height: 240px;overflow: hidden" :style="{ paddingBottom: isRole ? '40px' : '20px' }">
            <el-input @keydown.enter="goOrgAndRoleSearch" v-model="orgAndRoleSearchText" placeholder="请搜索">
              <template #prefix>
                <el-icon><Search /></el-icon>
              </template>
            </el-input>
            <template v-if="isOrgAndRoleSearch">
              <template v-if="isMultiple">
                <template v-if="isOrganize">
                  <el-checkbox-group v-model="value" @change="orgAndRoleSearchClick">
                    <el-checkbox v-for="(item) in orgAndRoleSearchList" :label="item" :key="item.organizationId">{{ showOrgName(item) }}</el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-else>
                  <el-checkbox-group v-model="value" @change="orgAndRoleSearchClick">
                    <el-checkbox v-for="(item) in orgAndRoleSearchList" :label="item" :key="item.roleId">{{ showOrgName(item) }}</el-checkbox>
                  </el-checkbox-group>
                </template>
              </template>
              <template v-else>
                <div class="org-and-role-search-single">
                  <div :style="{ backgroundColor: isActiveRoleAndOrg(item) ? themeColor : '', color: isActiveRoleAndOrg(item) ? '#fff' : ''  }" class="org-and-role-search-single-item" v-for="item in optSearchList" :key="isRole ? item.roleId : item.organizationId" @click="orgAndRoleSearchClick(item)">{{ showOrgName(item) }}</div>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-if="isRole">
                <template v-if="isMultiple">
                  <el-checkbox-group v-model="value" @change="orgAndRoleSearchClick">
                    <el-checkbox v-for="(item) in orgAndRoleList" :label="item" :key="item.roleId">{{ showOrgName(item) }}</el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-else>
                  <div class="org-and-role-search-single">
                    <div v-if="info.isAppenAll" :style="{ backgroundColor: isActiveRoleAndOrg('全部') ? themeColor : '', color: isActiveRoleAndOrg('全部') ? '#fff' : ''  }" class="org-and-role-search-single-item" @click="orgAndRoleSearchClick('全部')">全部</div>
                    <div :style="{ backgroundColor: isActiveRoleAndOrg(item) ? themeColor : '', color: isActiveRoleAndOrg(item) ? '#fff' : ''  }" class="org-and-role-search-single-item" v-for="item in optSearchList" :key="isRole ? item.roleId : item.organizationId" @click="orgAndRoleSearchClick(item)">{{ showOrgName(item) }}</div>
                  </div>
                </template>
              </template>
              <template v-else-if="isOrganize">
                <template v-if="isMultiple">
                  <el-checkbox-group v-model="value" @change="orgMutualCheck">
                    <el-checkbox v-for="(item) in orgAndRoleList" :label="item.organizationId" :key="item.organizationId">{{ showOrgName(item) }}</el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-else>
                  <div class="org-and-role-search-single">
                    <div :style="{ backgroundColor: isActiveRoleAndOrg(item) ? themeColor : '', color: isActiveRoleAndOrg(item) ? '#fff' : '' }" class="org-and-role-search-single-item" v-for="item in optSearchList" :key="isRole ? item.roleId : item.organizationId" @click="orgAndRoleSearchClick(item)">{{ showOrgName(item) }}</div>
                  </div>
                </template>
              </template>
            </template>
          </div>
        </el-popover>
      </template>
    </div>
  </div>
</template>

<script>
import optionItem from './optionItem.vue'
import { numConditionFn, dateConditionFn } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { colorRgb } from '@/components/schoolInstrument/mixins/utils'
import { getOrgShowName } from '@/api/global'
import { formatRole } from '@/components/schoolInstrument/component/mutual/component/screen/utils/utils'
export default {
  // 组件名称
  name: 'screenItem',
  // 组件参数 接收来自父组件的数据
  props: {
    options: {
      type: Array,
      default: () => ([])
    },
    screenType: {
      type: String,
      default: ''
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    isLeft: {
      type: Boolean,
      default: true
    },
    getFontStyle: {
      type: Object,
      default: () => ({})
    },
    info: {
      type: Object,
      default: () => ({})
    },
    masterInfo: {
      type: Object,
      default: () => ({})
    },
    masterValue: {

    },
  },
  // 局部注册的组件
  components: {
    optionItem
  },
  // 组件状态值
  data () {
    return {
      optSearch: '',
      checkAll: false,
      value: [],
      isAppenPop: false,
      conditionValue: '',
      orgAndRoleSearchText: '',
      userPopWidth: 320,
      isOrgAndRoleSearch: false,
      isOrgCheckAll: false
    }
  },
  // 计算属性
  computed: {
    btnProps() {
      return Object.assign({}, this.$props, this.$attrs)
    },
    isMultiple () {
      return this.info.filterMode !== 'single'
      // return true
    },
    isUser() {
      return this.cureentType === 'relation-user'
    },
    isOrganize () {
      return ['organization'].indexOf(this.cureentType) !== -1
    },
    isRole () {
      return ['roule'].indexOf(this.cureentType) !== -1
    },
    isDefault () {
      return ['orders', 'status', 'text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'relation-check', 'label'].indexOf(this.cureentType) !== -1
    },
    cureentType() {
      if (this.info.activeName === 'dictionary' || this.info.activeName === 'custom') {
        return 'text'
      }
      if (this.info.screenLevel && this.info.screenLevel.levelType === 'single' && this.info.screenLevel.levelList.length > 0) {
        const field = this.info.screenLevel.levelList[0].field
        return field.split('_')[2]
      } else {
        return this.info.cureentType || this.info.type
      }
    },
    isDate () {
      return ['date', 'timeof', 'dates'].indexOf(this.cureentType) !== -1
    },
    isNum () {
      return this.cureentType === 'number'
    },
    looperOption () {
      if (this.isDate) {
        return dateConditionFn()
      } else if (this.isNum) {
        return numConditionFn()
      } else if (this.isUser) {
        return this.userConditionFn
      } else if(this.isOrganize || this.isRole){
        return this.orgConditionFn
      } else {
        return []
      }
    },
    isBetween () {
      return this.conditionValue === 'between'
    },
    optSearchList() {
      if (this.optSearch) {
        return this.options.filter(item => {
          if (item && this.isObject(item)) {
            if (item.name) {
              return item.name.includes(this.optSearch)
            } else {
              return item.value.includes(this.optSearch)
            }
          } else if (item) {
            if (typeof item === 'number') {
              return item.toString().includes(this.optSearch)
            }
            return item.includes(this.optSearch)
          }
        })
      } else {
        return Array.from(new Set(this.options))
      }
    },
    orgAndRoleAppenText() {
      let li = []
      if (this.isOrganize) {
        li = this.value.map(item=> getOrgShowName(item))
      } else {
        li = this.value.map(item=> this.isObject(item) ? item.name : item)
      }
      return li
    },
  },
  // 侦听器
  watch: {
    value(val) {
      if (val[0] === '全部') {
        this.$emit('change', this.optSearchList, this.info, this.optSearchList)
      } else {
        this.$emit('change', val, this.info, this.optSearchList)
      }
    },
    masterValue: {
      handler (newValue, oldVal) {
        if ((newValue.length > 1 && newValue[0] !== '全部') && this.masterInfo.filterMode === 'single') {
          return
        }
        if (JSON.stringify(newValue) !== JSON.stringify(oldVal) || (newValue && JSON.stringify(newValue) === JSON.stringify(oldVal))) {
          if (this.optSearchList.length > 0) {
            if (this.info.isAppenAll) {
              this.value = ['全部']
            } else {
              this.value = [this.optSearchList[0]]
            }
          } else {
            this.value = []
          }
        }
      },

    }
  },
  // 组件方法
  methods: {
    init() {

    },
    removeTag (e) {
      if (this.isOrganize || this.isRole) {
        this.value = this.value.filter(c => c.name !== e)
      } else {
        if (e === '全部') {
          this.checkAll = false
        } else {
          let idx = -1
          const val = this.value[0]
          if (val && typeof val === 'object' && val !== null) {
            idx = this.value.findIndex(c => c.value === e)
          } else {
            idx = this.value.findIndex(c => c === e)
          }
          if (idx !== -1) {
            this.value.splice(idx, 1)
          }
        }
      }
    },
    orgAndRoleSearchClick (item) {
      const type = this.isOrganize ? 'organization' : 'role'
      if (item === '全部') {
        this.isOrgCheckAll = true
        this.changeCheck(this.optSearchList, type)
        return
      }
      this.isOrgCheckAll = false
      if (Array.isArray(item)) {
        this.changeCheck(item, type)
      } else {
        this.changeCheck([item], type)
      }
    },
    changeCheck(val, type = 'organization') {
      let list = []
      if (type === 'organization') {
        list = val
      } else {
        list = formatRole(val)
      }
      this.$set(this, 'value', list)
    },
    isActiveRoleAndOrg (item) {
      const key = this.isOrganize ? 'organizationId' : 'roleId'
      const li = this.value
      if (item === '全部' && li.length === this.optSearchList.length && this.isOrgCheckAll) return true
      for (const ele of li) {
        if (ele[key] === item[key]) {
          if (this.info.isAppenAll && li.length !== this.optSearchList.length) {
            return true
          }
          if (!this.info.isAppenAll) {
            return true
          }
          if (this.isOrgCheckAll === false) {
            return true
          }
        }
      }
    },
    showOrgName (item) {
      if (this.isOrganize) {
        return getOrgShowName(item)
      } else {
        return item.name
      }
    },
    checkChange() {

    },
    isObject(val) {
      return val !== null && typeof val === 'object'
    },
    showOrgAndRoleList() {
      this.isAppenPop = true
    },
    dealCondition() {

    },
    checkSingle(val) {
      if (Array.isArray(val)) {
        const last = val[val.length - 1]
        if (last === undefined) {
          this.value = []
        } else {
          this.value = [last]
        }
      } else {
        if (val === '全部') {
          this.value = ['全部']
        } else {
          this.$set(this.value, 0, val)
          this.checkAll = false
        }
      }
    },
    colorRgb(str, opc) {
      return colorRgb(str, opc)
    },
  },
}
</script>

<style scoped lang="scss">
$themeColor: var(--theme-color);
$opacityTheme: var(--opacity-theme);
.single-tree-head {
  padding: 0 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  ::v-deep .el-input {
    width: 90%;
  }
  .el-icon-refresh-right {
    cursor: pointer;
    color: #4E86FF;
    margin-left: 8px;
    line-height: 32px;
    font-size: 24px;
  }
}

.org-and-role-search-single {
  &-item {
    height: 30px;
    line-height: 30px;
    padding: 0 16px;
    box-sizing: border-box;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    color: #333;
    white-space: nowrap;
    border-radius: 4px;
  }
}

::v-deep.screen-item-left {
  padding: 0 10px;
  .single-item {
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    min-height: 30px;
    font-weight: 400;
    font-size: 16px;
    font-family: PingFangSC;
    cursor: pointer;
    position: relative;
    padding: 0 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .single-item-active {
    color: $themeColor !important;
    background-color: #4e86ff;
    &::after {
      content: '';
      background-color: $themeColor;
      position: absolute;
      height: 100%;
      width: 2px;
      left: 0;
      top: 0;
    }
  }
  &-opt {
    margin-left: 28px;
    transition: .3s;
    overflow: hidden;
    .el-checkbox {
      .el-checkbox__label {
        padding-left: 5px;
      }
    }

    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: $themeColor;
      border-color: $themeColor;
    }
    .is-checked {
      .el-checkbox__label {
        color: $themeColor;
      }
      .el-checkbox__input {
        .el-checkbox__inner {
          background-color: $themeColor;
          border-color: $themeColor;
        }
      }
    }
  }
}

.screen-item-top {
  margin-top: 0 !important;
  .single-item {
    height: 30px;
    line-height: 30px;
    font-weight: 400;
    font-size: 16px;
    position: relative;
    cursor: pointer;
    color: #333;
    white-space: nowrap;
    &:first-of-type {
      margin-left: 0;
    }
  }
  .single-item-active {
    color: $themeColor !important;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: $themeColor;
    }
    .option-item-text {
      color: $themeColor !important;
    }
  }
}
.screen-item {
  margin-top: 5px;
  background-color: #fff;
  &-condition {
    display: flex;
  }
  .verticalL {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
    flex: 1;
    position: relative;
    &-item {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      transition: .3s;
      width: 100%;
    }
    .change-tab {
      width: 30px;
      height: 100%;
      position: absolute;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      &-item {
        width: 14px;
        margin-right: 2px;
        display: flex;
        align-items: center;
        color: $themeColor;
        cursor: pointer;
        height: 100%;
        .is-disabled {
          color: #D8D8D8 !important;
        }
        .iconfont {
          font-size: 12px;
        }
        .icon-xia {
          display: inline-block;
          transform: rotate(90deg);
        }
        &:last-of-type {
          margin-right: 0;
        }
        &:hover {
          background-color: $opacityTheme;
        }
      }
      .disabled {
        color: #D8D8D8;
      }
    }
    .el-checkbox {
      height: 30px;
      line-height: 30px;
    }
    ::v-deep .el-scrollbar {
      .el-scrollbar__wrap {
        overflow-x: auto !important;
        .el-scrollbar__view {
          display: flex;
        }
      }
    }
    .single-item {
      height: 30px;
      line-height: 30px;
      margin: 0 12px;
      font-weight: 400;
      font-size: 16px;
      position: relative;
      cursor: pointer;
      color: #333;
      white-space: nowrap;
      &:first-of-type {
        margin-left: 0;
      }
    }
    .single-item-active {
      color: $themeColor !important;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: $themeColor;
      }
      .option-item-text {
        color: $themeColor !important;
      }
    }
  }
}





::v-deep .el-popover__reference-wrapper {
  width: 100%;
  .el-select {
    width: 100%;
  }
}

::v-deep .el-select {
  .el-select__tags {
    flex-wrap: nowrap;
  }
  .el-input__suffix {
    .el-select__caret, .el-icon-search {
      line-height: 30px;
    }
  }
}

::v-deep .el-input {
  height: 30px;
  line-height: 30px;
  .el-input__inner {
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
  .el-input__prefix {
    .el-icon-search {
      line-height: 30px;
    }
  }
}

</style>

